// extracted by mini-css-extract-plugin
export var PreFooter = "styles-module--PreFooter--Wvh8A";